import React, { memo, useMemo, lazy, Suspense } from 'react'
import { useSelector } from 'react-redux'
import useDirection from 'utils/hooks/useDirection'
import useLocale from 'utils/hooks/useLocale'
import WebsiteLoader from 'components/shared/WebsiteLoader'
import Website from 'views/Website/Index'

const Layout = () => {
	useDirection();
	useLocale();

	const loadingElement = (
		<div className="flex flex-auto flex-col h-[100vh] justify-center items-center">
			<WebsiteLoader />
		</div>
	);

	return (
		<Suspense fallback={loadingElement}>
			<Website />
		</Suspense>
	)
}

export default memo(Layout)